export function tryCatch(fn){
	try {
		return {
			caught: false,
			value: fn(),
		}
	}
	catch (error){
		return {
			caught: true,
			error,
		}
	}
}

export async function tryCatchAsync(fn){
	try {
		return {
			caught: false,
			value: await fn(),
		}
	}
	catch (error){
		return {
			caught: true,
			error,
		}
	}
}